<template>
    <div class="user-list">
        <div class="search-user">
            <el-input v-model="searchText" class="search-text" placeholder="输入用户名或手机号" @keyup.enter="searchUser" />
            <el-button class="search-btn" type="primary" @click="searchUser()">搜索</el-button>
        </div>
        <div class="context-user">
            <el-table ref="teamTable" :data="userList" row-key="userId" style="width: 100%"
                :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
                <el-table-column prop="userId" label="用户编号" />
                <el-table-column prop="nickName" label="真实姓名" />

                <el-table-column prop="userName" label="用户名" />
                <el-table-column prop="phonenumber" label="用户电话" />
                <el-table-column prop="sex" label="性别">
                    <template #default="scope">
                        {{ scope.row.sex === '1' ? '女' : '男' }}
                    </template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" min-width="70">
                    <template #default="scope">
                        <el-button link type="primary" size="small" @click="handleEdit(scope)">
                            编辑
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>

            <el-dialog v-model="dialogVisible" :show-close="false" width="800" @click.stop>
                <template #header="{ close, titleId, titleClass }">
                    <div class="user-info-header">
                        <h4 :id="titleId" :class="titleClass">用户编辑</h4>
                        <div class="user-info-close" @click.stop="close">×</div>
                    </div>
                </template>
                <div class="user-info-context">
                    <el-form :model="currentUser" label-width="80px">
                        <el-form-item label="用户编号">
                            <el-input v-model="currentUser.userId" disabled />
                        </el-form-item>
                        <el-form-item label="真实姓名">
                            <el-input v-model="currentUser.nickName" />
                        </el-form-item>
                        <el-form-item label="用户名">
                            <el-input v-model="currentUser.userName" />
                        </el-form-item>
                        <el-form-item label="用户电话">
                            <el-input v-model="currentUser.phonenumber" />
                        </el-form-item>
                        <el-form-item label="性别">
                            <el-select v-model="currentUser.sex" placeholder="请选择性别">
                                <el-option label="男" value="0" />
                                <el-option label="女" value="1" />
                            </el-select>
                        </el-form-item>
                    </el-form>

                </div>
                <template #footer>
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="updateUserInfo">保存</el-button>
                </template>
            </el-dialog>
        </div>

    </div>
</template>

<script>
import { getUserApiList, updateUserInfo } from '@/api/Common';
import { useMapStore } from '@/stores/mapStore';
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
    name: "TeamSetting",
    components: {},
    data() {
        return {
            searchText: "",
            userInfo: null,
            mapStore: null,
            userList: [],
            dialogVisible: false,  // 控制编辑面板显示
            currentUser: null      // 当前编辑的用户
        };
    },
    mounted() {

        this.mapStore = useMapStore();

        this.userInfo = this.mapStore.getUserInfo();

        this.searchUser();


    },

    methods: {
        handleEdit(scope) {
            this.currentUser = scope.row;
            this.dialogVisible = true;
        },
        updateUserInfo(){
            let that = this;
            updateUserInfo(this.currentUser).then(res => {
                if (res.code == 200) {
                    that.dialogVisible = false;
                    that.searchUser();

                    ElMessage.success("修改成功！");
                }
            });
            
        },
        searchUser() {
            let phoneParams = {
                userId: this.userInfo.userId
            }
            if (this.searchText.trim() != "") {
                phoneParams.phonenumber = this.searchText.trim();
            }
            this.searchData = [];
            this.searchDataKey = [];
            //
            let that = this;

            getUserApiList(phoneParams).then(res => {
                if (res.code == 200) {
                    that.userList = res.datas;
                }
            });

        },
    },
};
</script>

<style scoped>
.el-dialog {
    padding: 0px !important;
}

.user-info-close {
    color: #fff;
    font-size: 26px;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
}

.user-info-header {
    position: relative;
    height: 46px;
    padding:
        12px;
    background-color: #1b2d3e;
    color: #fff;
    border-radius:
        5px 5px 0 0;

}

.user-info-header h4 {
    color: #fff;
}

.user-info-context {
    padding: 10px;
}




.user-list {
    overflow: auto;
    position: relative;
    height: 100%;
    width: 100%;
    background-color: #f0f2f5;
}

.search-user {
    height: 80px;
    border-radius: 10px;
    background-color: white;
    margin: 10px;

}

.search-text {
    margin-left: 20px;
    width: calc(100% - 100px);
    height: 40px;
    margin-top: 20px;
    border: 1px solid #eee;

}

.search-btn {
    height: 40px;
    margin-top: 20px;
}

.context-user {
    height: calc(100% - 90px);
    background-color: white;
    border-radius: 10px;
    margin: 10px;
}
</style>
